import React from "react";

export const SignPreview = React.forwardRef(({ sign, className = "", style = {} }, ref) => {
  return (
    <div
      ref={ref}
      className={`sign-paper ${className}`}
      style={style}
      data-testid="sign-paper"
    >
      <div className="sign-product" data-testid="sign-product-name">
        {sign.product_name || " "}
      </div>

      <div className="sign-yellow" data-testid="sign-yellow-box">
        <div className="sign-price-label">{sign.price_label}</div>
        <div className="sign-price-row">
          <span className="sign-price-whole">{sign.price_whole}</span>
          {sign.price_decimal ? (
            <span className="sign-price-decimal">{sign.price_decimal}</span>
          ) : null}
        </div>
      </div>

      {sign.show_bar ? (
        <div
          className="sign-bar"
          data-testid="sign-bar"
          style={{ whiteSpace: "pre-line" }}
        >
          {sign.bar_text}
        </div>
      ) : null}

      {sign.show_date ? (
        <div
          className="sign-date"
          data-testid="sign-date"
          style={{ fontSize: `${sign.date_size ?? 8}mm`, whiteSpace: "pre-line" }}
        >
          {[sign.date_label, sign.date_value].filter(Boolean).join(" ")}
        </div>
      ) : null}
    </div>
  );
});

SignPreview.displayName = "SignPreview";
